import {
  INIT_SIGNIN,
  CHANGE_FREETRIAL_STATUS,
  SET_TRIAL_STATUS,
  UPDATE_PAYMENT_STATUS,
  UPDATE_EXISTING_USER_STATUS,
  INIT_SIGNOUT,
  INIT_PLAYER,
  INIT_CHAPTER_LIST,
  UPDATE_PROFILE,
  UPDATE_NAME,
  CHANGE_ACTIVE_MODULE,
  DESTROY_PLAYER,
  INIT_PUZZLE,
  CHANGE_QUESTION,
  SET_PUZZLE_PROGRESSID,
  SELECTED_OPTION,
  UPDATE_BACKGROUND_THEME,
  UPDATE_STUDENT_MODAL_STATUS,
  INIT_IDE,
  CHANGE_STATEMENT,
  SET_CHALLENGE_PROGRESSID,
  SAVE_CODE,
  SET_ACCESS_TOKEN,
  VIDEO_FINISHED,
  START_QUIZ,
  INIT_QUIZ,
  ANSWSER_SUBMIT,
  SAVE_TESTCASE_RESPONSES_QUIZ,
  CHANGE_QUIZ_QUESTION,
  GET_RESULT,
  RESET_QUIZ,
  SAVE_TESTCASE_RESPONSES,
  TESTCASE_COMPLETED,
  HIDE_SNACKBAR,
  SAVE_MODULE_DETAILS,
  UPDATE_USER_LEGALNAME,
  UPDATE_USER_LOCATION_DETAILS,
  UPDATE_USER_LOCATION_FROM,
  PROBLEM_COMPLETED_MODAL,
  PUZZLE_COMPLETED_MODAL,
  UPDATE_USER_SURVEY_ANSWER,
  UPDATE_USER_SURVEY_STATUS,
  SAVE_PHONENUMBER_MODEL,
  SAVE_COURSEUPGRADE_DATA,
  TOGGLE_SITE_THEME,
} from './actionTypes';
import {
  INIT_SEGMENTS,
  START_SEGMENT_IMPRESSION,
  END_SEGMENT_IMPRESSION,
  VIDEO_PAUSE,
  VIDEO_PLAY,
  VIDEO_SEEK,
  SEGMENT_START,
  SEGMENT_FINISHED,
  PROGRESS_SECOND_UPDATE,
  UPDATE_MODULE_COMPLETED,
  INIT_POINTS_MASTER_DATA,
} from './actionTypes';
import {
  SET_CURRENCY,
  CUSTOM_PRICING_PLAN,
  CLEAR_CHECKOUT,
  PRICING_PLAN,
  UPDATE_CHECKOUT_PROMO_CODE,
  UPDATE_OFFER_STATUS,
  UPDATE_OFFER_NAME,
  PAYEE_INFO,
  UPDATE_SIGNUP_PATH,
  UPDATE_PURCHASED_PATH,
  INIT_AFFILIATE_USER,
  REFERRAL_REDEEM_STATUS,
  UPDATE_REFERRAL_PAYMENT_INFO,
  UPDATE_PROMO_AMOUNT,
  SAVE_LINKEDIN_POST,
} from './actionTypes';
import {
  DEVELOPMENT_ENVIRONMENT,
  OTP_VERIFYID,
  UPDATE_REFERRAL_MODAL,
  SAVE_ALL_COURSES,
  SAVE_IN_PROGRES_COURSES,
  UPDATE_MYCOURSES,
  UPDATE_PHONE_NO_VERIFIED,
  SAVE_CHAPTER_LIST,
  SAVE_OTHER_INPROGRESS_COURSES,
  SAVE_VIDEO_COMPLETE_STATUS,
  SAVE_USER_PROGRESS,
  SAVE_USER_PROFILE_DETAILS,
  SAVE_SUBSCRIPTION_TYPE,
  SAVE_PAYMENT_GATEWAY_TYPE,
  SAVE_INDIAN_CURRENCY_PLAN,
  SHOW_PRICING_TOGGLE,
  SET_PROMO_PERCENTAGE,
  SET_SUBSCRIPTION_PLAN,
} from './actionTypes';

/**
 * Authentication - Actions
 */
export const Signin = (user) => ({
  type: INIT_SIGNIN,
  user,
});

export const Signout = () => ({
  type: INIT_SIGNOUT,
});

/**
 * User located from
 */

export const updateUserLocationFrom = (details) => ({
  type: UPDATE_USER_LOCATION_FROM,
  details,
});

export const updateUserOnBoardingModalStatus = (status) => ({
  type: SAVE_PHONENUMBER_MODEL,
  status,
});

export const updateUserSurveyAnswer = (answerDetails) => ({
  type: UPDATE_USER_SURVEY_ANSWER,
  answerDetails,
});

/**
 * User Free Trial Expire -Actions
 */

export const changeExpireStatus = (status) => ({
  type: CHANGE_FREETRIAL_STATUS,
  status,
});

export const setTrialStatus = (details) => ({
  type: SET_TRIAL_STATUS,
  details,
});

export const updateExistingUserStatus = (status) => ({
  type: UPDATE_EXISTING_USER_STATUS,
  status,
});

export const updateMyCourses = (mycourses) => ({
  type: UPDATE_MYCOURSES,
  mycourses,
});

export const updatePhoneNoVerified = (phoneNoVerified) => ({
  type: UPDATE_PHONE_NO_VERIFIED,
  phoneNoVerified,
});

export const updateReferralModal = (status) => ({
  type: UPDATE_REFERRAL_MODAL,
  status,
});

export const updatePaymentStatus = (foundationStatus, paymentStatus) => ({
  type: UPDATE_PAYMENT_STATUS,
  foundationStatus,
  paymentStatus,
});

export const updateSignupPath = (signup_path) => ({
  type: UPDATE_SIGNUP_PATH,
  signup_path,
});

export const updatePurchasedPath = (purchasedPaths) => ({
  type: UPDATE_PURCHASED_PATH,
  purchasedPaths,
});

export const updateBackgroundTheme = (themeStatus) => ({
  type: UPDATE_BACKGROUND_THEME,
  themeStatus,
});

export const updateStudentModalStatus = (optionModalStatus, mailModalStatus) => ({
  type: UPDATE_STUDENT_MODAL_STATUS,
  optionModalStatus,
  mailModalStatus,
});

export const toggleSiteTheme = (themeStatus) => ({
  type: TOGGLE_SITE_THEME,
  themeStatus,
});

/**
 * Player - Actions
 */

export const InitPlayer = (courseID, chapterID, moduleID, slug) => ({
  type: INIT_PLAYER,
  courseID,
  chapterID,
  moduleID,
  slug,
});

export const hideSnackBar = () => ({
  type: HIDE_SNACKBAR,
});

export const InitChapterList = (chapters) => ({
  type: INIT_CHAPTER_LIST,
  chapters,
});

export const changeActiveModule = (moduleID, chapterID) => ({
  type: CHANGE_ACTIVE_MODULE,
  moduleID,
  chapterID,
});

export const tearDown = () => ({
  type: DESTROY_PLAYER,
});

/**
 * Quiz - Actions
 */

export const InitPuzzle = (question, isPreviouslyCompleted, puzzlelastAttempt) => ({
  type: INIT_PUZZLE,
  question,
  isPreviouslyCompleted,
  puzzlelastAttempt,
});

export const ChangeQuestion = (value) => ({
  type: CHANGE_QUESTION,
  value,
});

export const SelectedOption = (id, selected, status, questionType, progress, details, ruleSets) => (dispatch, getState) => {
  const { Puzzle } = getState();
  const isPreviouslyCompleted = Puzzle.isPreviouslyCompleted || Puzzle.isCompleted;
  dispatch({
    type: SELECTED_OPTION,
    selected,
    id,
    status,
    questionType,
    progress,
    details,
    ruleSets,
    isPreviouslyCompleted,
  });
};

export const setPuzzleProgressID = (progressID) => ({
  type: SET_PUZZLE_PROGRESSID,
  progressID,
});

/**
 * IDE - Actions
 */

export const InitIde = (question, points, isPreviouslyCompleted) => ({
  type: INIT_IDE,
  question,
  points,
  isPreviouslyCompleted,
});

export const ChangeStatement = (value) => ({
  type: CHANGE_STATEMENT,
  value,
});

export const SaveCode = (id, code, progress) => ({
  type: SAVE_CODE,
  id,
  code,
  progress,
});

export const ProfileData = (picture, phoneNumber, phoneNoVerified) => ({
  type: UPDATE_PROFILE,
  picture,
  phoneNumber,
  phoneNoVerified,
});

export const UpdateName = (name, profilePic) => ({
  type: UPDATE_NAME,
  name,
  profilePic,
});

export const setAccessToken = (token) => ({
  type: SET_ACCESS_TOKEN,
  token,
});

export const setChallengeProgressID = (progressID) => ({
  type: SET_CHALLENGE_PROGRESSID,
  progressID,
});

export const saveTestCaseResponse = (id, testCaseID, status, output, code) => ({
  type: SAVE_TESTCASE_RESPONSES,
  id,
  testCaseID,
  status,
  output,
  code,
});

export const testCaseCompleted = (id, isCompleted, isPreviouslyCompleted, testCaseLength, ruleSets, details) => ({
  type: TESTCASE_COMPLETED,
  id,
  isCompleted,
  isPreviouslyCompleted,
  testCaseLength,
  ruleSets,
  details,
});

/**
 * Video - Progress
 */

export const initSegments = (moduleID, info, segments, courseID, isVideoCompleted) => ({
  type: INIT_SEGMENTS,
  moduleID,
  segments,
  info,
  courseID,
  isVideoCompleted,
});

export const startScreenCards = (moduleID, info) => ({
  type: START_SEGMENT_IMPRESSION,
  moduleID,
  info,
});

export const endScreenCards = (moduleID, info) => ({
  type: END_SEGMENT_IMPRESSION,
  moduleID,
  info,
});

export const pauseVideo = (moduleID, info, courseID) => ({
  type: VIDEO_PAUSE,
  moduleID,
  info,
  courseID,
});

export const playVideo = (moduleID, info, courseID) => ({
  type: VIDEO_PLAY,
  moduleID,
  info,
  courseID,
});

export const seekVideo = (moduleID, info, courseID) => ({
  type: VIDEO_SEEK,
  moduleID,
  info,
  courseID,
});

export const startSegment = (moduleID, info, segmentIndex, segmentDetails, courseID) => ({
  type: SEGMENT_START,
  moduleID,
  info,
  segmentIndex,
  segmentDetails,
  courseID,
});

export const endSegment = (moduleID, info, segmentIndex, segmentDetails) => ({
  type: SEGMENT_FINISHED,
  moduleID,
  info,
  segmentIndex,
  segmentDetails,
});

export const updateProgressSecond = (moduleID, info, segmentIndex, segmentDetails) => ({
  type: PROGRESS_SECOND_UPDATE,
  moduleID,
  info,
  segmentIndex,
  segmentDetails,
});

export const videoFinished = (moduleID, info) => (dispatch, getState) => {
  const { Player, Video, Learning } = getState();
  const isPreviouslyCompleted = Video[moduleID] && (Video[moduleID].isPreviouslyCompleted || Video[moduleID].isCompleted);
  dispatch({
    type: VIDEO_FINISHED,
    courseID: Learning.courseDetails.courseID,
    moduleID: Learning.moduleDetails.moduleID,
    isPreviouslyCompleted,
    info,
  });
};

export const initRuleSets = (points, ruleSets, userID, problemPoints) => ({
  type: INIT_POINTS_MASTER_DATA,
  problemPoints,
  points,
  ruleSets,
  userID,
});

export const updateModuleCompleted = (moduleID, chapterID) => ({
  type: UPDATE_MODULE_COMPLETED,
  moduleID,
  chapterID,
});

/**
 * Quiz - Actions
 */

export const startQuiz = (progressID) => ({
  type: START_QUIZ,
  progressID,
});

export const initQuiz = (question, moduleComplete) => ({
  type: INIT_QUIZ,
  question,
  moduleComplete,
});

export const answerSubmit = (questionID, answerSubmitted, questionType, progressID, responseID, testCases) => ({
  type: ANSWSER_SUBMIT,
  questionID,
  questionType,
  answerSubmitted,
  progressID,
  responseID,
  testCases,
});

export const saveTestCaseResponseQuiz = (questionID, testCaseID, status, output, code) => ({
  type: SAVE_TESTCASE_RESPONSES_QUIZ,
  questionID,
  testCaseID,
  status,
  output,
  code,
});

export const changeQuizQuestion = (value) => ({
  type: CHANGE_QUIZ_QUESTION,
  value,
});

export const getResult = (result, points) => (dispatch, getState) => {
  const Quiz = getState().Quiz;
  return dispatch({
    type: GET_RESULT,
    result,
    points,
    moduleComplete: Quiz.moduleComplete,
  });
};

export const resetQuiz = () => ({
  type: RESET_QUIZ,
});

/**
 * Pricing - Actions
 */

export const setCurrency = (currency, currencySymbol, countryCode) => ({
  type: SET_CURRENCY,
  currency,
  currencySymbol,
  countryCode,
});

export const customPricingPlan = (selectedCourses, totalAmount) => ({
  type: CUSTOM_PRICING_PLAN,
  selectedCourses,
  totalAmount,
});

export const pricingPlan = (selectedCourses) => ({
  type: PRICING_PLAN,
  selectedCourses,
});

export const totalAmountToPay = (amountToPay) => ({
  type: UPDATE_PROMO_AMOUNT,
  amountToPay,
});

export const clearCheckOut = () => ({
  type: CLEAR_CHECKOUT,
});

export const updateCheckoutPromoCode = (promoCode) => ({
  type: UPDATE_CHECKOUT_PROMO_CODE,
  promoCode,
});

export const updateOfferStatus = (status) => ({
  type: UPDATE_OFFER_STATUS,
  status,
});

export const updateOfferName = (value) => ({
  type: UPDATE_OFFER_NAME,
  value,
});

export const updatePayeeInfo = (info) => ({
  type: PAYEE_INFO,
  info,
});

export const referralRedeemStatus = (status) => ({
  type: REFERRAL_REDEEM_STATUS,
  status,
});

/** Init Affiliate User ID */
export const initAffiliateUser = (id) => ({
  type: INIT_AFFILIATE_USER,
  id,
});

export const developmentEnvironment = (status) => ({
  type: DEVELOPMENT_ENVIRONMENT,
  status,
});

export const otpVerifyID = (verifyID) => ({
  type: OTP_VERIFYID,
  verifyID,
});

export const saveAllCourses = (allCourses) => ({
  type: SAVE_ALL_COURSES,
  allCourses,
});

export const saveInProgressCourses = (trialAndInProgress) => ({
  type: SAVE_IN_PROGRES_COURSES,
  trialAndInProgress,
});

export const saveChapterList = (courseDetails) => ({
  type: SAVE_CHAPTER_LIST,
  courseDetails,
});

export const saveModuleDetails = (moduleDetails) => ({
  type: SAVE_MODULE_DETAILS,
  moduleDetails,
});

export const saveOtherInProgress = (otherInprogressCourses) => ({
  type: SAVE_OTHER_INPROGRESS_COURSES,
  otherInprogressCourses,
});

export const updateSurveyAnseredStatus = (updatedSurveyAnseredStatus) => ({
  type: UPDATE_USER_SURVEY_STATUS,
  updatedSurveyAnseredStatus,
});

export const saveVideoCompleteStatus = (videoStatus, hintStatus, solutionStatus, completionStatus) => ({
  type: SAVE_VIDEO_COMPLETE_STATUS,
  videoStatus,
  hintStatus,
  solutionStatus,
  completionStatus,
});

export const updateReferralPaymentDetails = (referralInfo) => ({
  type: UPDATE_REFERRAL_PAYMENT_INFO,
  referralInfo,
});

export const saveLinkedInPost = (postText, image, issuedStatus) => ({
  type: SAVE_LINKEDIN_POST,
  postText,
  image,
  issuedStatus,
});

export const updateUserLegalName = (legalName, code, status) => ({
  type: UPDATE_USER_LEGALNAME,
  legalName,
  code,
  status,
});

export const updateUserLocationDetails = (locationDetails) => ({
  type: UPDATE_USER_LOCATION_DETAILS,
  locationDetails,
});

export const saveUserProgress = (userProgress) => ({
  type: SAVE_USER_PROGRESS,
  userProgress,
});

export const saveprofileDetails = (profileDetails) => ({
  type: SAVE_USER_PROFILE_DETAILS,
  profileDetails,
});

export const saveSubscriptionType = (subscriptionType) => ({
  type: SAVE_SUBSCRIPTION_TYPE,
  subscriptionType,
});

export const problemCompletedModal = (status) => ({
  type: PROBLEM_COMPLETED_MODAL,
  status,
});

export const puzzleCompletedModal = (status) => ({
  type: PUZZLE_COMPLETED_MODAL,
  status,
});

/* Notifications */

export const saveCourseUpgradeData = (courseUpgradeData) => ({
  type: SAVE_COURSEUPGRADE_DATA,
  courseUpgradeData,
});

export const savePaymentGatewayType = (gatewayType) => ({
  type: SAVE_PAYMENT_GATEWAY_TYPE,
  gatewayType,
});

export const setIndianCurrencyPricingPlan = (selectedIndianInrPrice, selectedIndianUSDPrice) => ({
  type: SAVE_INDIAN_CURRENCY_PLAN,
  selectedIndianInrPrice,
  selectedIndianUSDPrice,
});

export const showPricingToggle = (pricingToggleStatus) => ({
  type: SHOW_PRICING_TOGGLE,
  pricingToggleStatus,
});

export const setPromoPercentage = (promoPercentValue) => ({
  type: SET_PROMO_PERCENTAGE,
  promoPercentValue,
});

export const setSubscriptionPlan = (status) => ({
  type: SET_SUBSCRIPTION_PLAN,
  status,
});
